import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { update_bed_status } from '@/api/mjstore-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { message } from 'ant-design-vue';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '设为空闲',
    clazz: 'default',
    is_show: (record: any) => {
      return record.status != 0;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      update_bed_status({
        bed_id: record.id,
        status: 0,
        org_id: current_org?.id,
      }).then(function (res) {
        message.success('设置成功');
        Object.assign(record, res);
      });
    },
  },
  {
    name: '设为正在使用',
    clazz: 'danger',

    is_show: (record: any) => {
      return record.status != 1;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      update_bed_status({
        bed_id: record.id,
        status: 1,
        org_id: current_org?.id,
      }).then(function (res) {
        message.success('设置成功');
        Object.assign(record, res);
      });
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
